// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__6OlyM","header":"PatientBlock_header__3Hi13","label":"PatientBlock_label__3F6we","option":"PatientBlock_option__FPZyJ"};